import React from "react"
import toast from "react-hot-toast"
import { AlertCircle } from "lucide-react"
import ErrorSummary from "components/Custom/ValidationAlert/ErrorSummary"
import { groupMissingByIndexAndFields } from "components/Custom/ValidationAlert/errorParser"

interface ValidationAlertProps {
  errors: any
  sectionName?: string
}

const ValidationAlert: React.FC<ValidationAlertProps> = ({ errors, sectionName = "esta sección" }) => {
  const showErrorDetails = () => {
    const isDirectMessage = errors && typeof errors === "object" && !Array.isArray(errors) && errors.message
    const parsedErrors = isDirectMessage ? null : groupMissingByIndexAndFields(errors)

    toast.custom(
      (t) => (
        <div
          className={`${
            t.visible ? "animate-enter" : "animate-leave"
          } bg-white max-w-md w-full shadow-lg rounded-lg pointer-events-auto flex flex-col ring-1 ring-border`}
        >
          <div className="w-full flex">
            <div className="w-full flex flex-col items-start gap-2">
              <div className="w-full flex flex-row items-start justify-start p-4 gap-2 bg-[#FFDA9B] rounded-tl-lg rounded-tr-lg">
                <AlertCircle className="h-5 w-5 text-destructive" />
                <p className="text-sm font-medium text-card-foreground">Errores de validación en {sectionName}</p>
              </div>
              <div className="text-sm text-muted-foreground max-h-60 overflow-y-auto px-4">
                {isDirectMessage ? (
                  <p className="text-sm mb-2 pt-2">{errors.message}</p>
                ) : (
                  <ErrorSummary errors={parsedErrors} />
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center justify-end p-2">
            <button
              onClick={() => toast.dismiss(t.id)}
              className="w-auto py-1 px-2 border rounded-lg text-sm font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-border"
            >
              Cerrar
            </button>
          </div>
        </div>
      ),
      {
        duration: 5000,
      },
    )
  }

  return (
    <span onClick={showErrorDetails} className="font-semibold underline cursor-pointer">
      Más info
    </span>
  )
}

export default ValidationAlert
